import { EnumBalcaoSalao } from './../../../enums/enum-balcao-salao';

export class SaloesCadastroFormModel {
    constructor(
        public balcao: EnumBalcaoSalao = EnumBalcaoSalao.UTILIZA,
        public descricao: string = ''
    ) { }
}